/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Confirm/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Confirm({
  children,
  viewPath = "/App/Auth/SignUpConfirm/Content/Confirm",
  onSubmit,
  isSubmitting
  
}) {
let signupConfirmSubmitData = fromData.useDataSubmit({ viewPath,
context: 'signup_confirm',
})
let signupConfirmIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'signup_confirm',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 block={true}
 marginTop={dtSpaceL}
 data="signup_confirm"
 onClick={signupConfirmSubmitData}
 disabled={signupConfirmIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Create My Account"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}